<script>
import "bootstrap-vue/dist/bootstrap-vue.css";
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import ItemForm from "@/components/modals/item-form-modal.vue"
export default {
    components: {
        ItemForm
    },
    props: {
        tableBusy: {
            type: Boolean,
            default: false
        },
        tableData: {
            type: Array,
            default: () => []
        },
        itemCats: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            sortBy: "trimmedItemName",
            sortDesc: false,
            fields: [
                {
                    key: "trimmedItemName",
                    sortable: true,
                    label: 'Item Name',
                },
                {
                    key: "itemCategory",
                    sortable: true,
                    label: "Category",
                    thStyle: { width: "150px" },
                },
                {
                    key: "unit",
                    sortable: true,
                    label: "Unit",
                    thStyle: { width: "120px" },
                },
                {
                    key: "type",
                    sortable: true,
                    label: "Type",
                    thStyle: { width: "120px" },
                },
                {
                    key: "cost",
                    sortable: true,
                    label: "Unit Cost",
                    thStyle: { width: "90px" },
                },
                {
                    key: "actions",
                    thStyle: { width: "90px" },
                },
            ],
            sideBar: false,
            filter: '',
            lazyFilter: '',
            isLazyFilterActive: false,
            filterBtn: false,
            priceRange: {
                from: '',
                to: ''
            },
            itemCat: 'All'
        }
    },
    computed: {
        filteredData() {
            let data = this.tableData;
            if(this.priceRange.from && this.priceRange.to){
                data = data.filter(x => x.unitCost >= this.priceRange.from && x.unitCost <= this.priceRange.to);
            }
            if(this.itemCat !== 'All'){
                data = data.filter(x => x.itemCategory.toLowerCase() === this.itemCat.toLowerCase());
            }
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toLowerCase()
                        .includes(this.filter.toLowerCase());
                });
            }
            return data;
        },
        rows() {
            if((this.priceRange.from && this.priceRange.to) || this.itemCat !== 'All' || (this.filter && this.filter.trim() != "")){
                return this.filteredData.length;
            }
            return this.tableData.length;
        },
    },
    methods: {
        updateItem(props) {
            let data = cloneDeep(props.item);
            this.indexSelected = this.tableData.indexOf(data);
            data.stockId = props.item.stockId ?? 0;
            data.formSubType = props.item.subType;
            data.unitCost = props.item.unitCost.toString();
            data.unitFormName = props.item.unit;
            data.formItemCategory = props.item.itemCategory;
            data.formStockId = props.item.stockId;
            this.modalTitle = "Update Item";
            this.$refs.itemForm.putData(data);
            this.$bvModal.show("item-form-modal");
        },
        deleteItem(props) {
            var index = this.tableData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("item/DeleteItem", props.item.id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.tableData.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        onCreate(modalData) {
            var data = cloneDeep(modalData);
            data.unitCost = this.getExactAmt(modalData.unitCost);
            data.campusId = this.$store.state.data.selectedCampus.id;
            this.$store
                .dispatch("item/UpdateItem", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    data.filterKey = `${data.itemName} ${data.description}`;
                    data.cost = this.formatCurrency(data.unitCost);
                    data.unit = data.unit.unitName;
                    data.itemCategory = data.itemCategory.name;
                    let index = this.tableData.findIndex(x => x.id == data.id);
                    this.tableData.splice(index, 1, data);
                    this.$bvModal.hide("item-form-modal");
                    this.showToast("Successfully updated!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong! - updating item", "error");
                });
        },
        dropUnit(data){
            this.$refs.itemForm.dropUnit(data);
        },
        dropItemCat(data){
            this.$refs.itemForm.dropItemCat(data);
        }
    }
}
</script>
<template>
    <div>
        <div class="position-fixed" style="bottom:50px;right:50px;z-index:1000;">
            <button class="btn btn-rounded btn-success" @click="sideBar = true;"><i class="bx bx-search"></i> View Item List</button>
        </div>
        <b-sidebar
            v-model="sideBar"
            width="90em"
            bg-variant="dark"
            text-variant="light"
            shadow
            no-header
            backdrop
            right
        >
            <div>
                <div class="d-flex align-items-center justify-content-between p-4">
                    <h3>Item List</h3>
                    <i class="bx bx-x cursor-pointer" style="font-size:40px;" @click="sideBar = false;"></i>
                </div>
                <div class="d-flex justify-content-between px-2">
                    <!-- Search -->
                    <div >
                        <form @submit.prevent="filter = lazyFilter">
                            <div class="d-flex flex-column mb-2">
                                <label
                                    class="d-inline-flex align-items-center mb-0"
                                >
                                    <b-form-input
                                        autocomplete="off"
                                        v-model="lazyFilter"
                                        @focus="isLazyFilterActive = true"
                                        @blur="isLazyFilterActive = false"
                                        type="search"
                                        placeholder="Search..."
                                        class="form-control form-control-sm ms-2 me-1"
                                    ></b-form-input>
                                    <b-form-select
                                        style="width:70px"
                                        class="form-select form-select-sm"
                                        v-model="perPage"
                                        size="sm"
                                        :options="pageOptions"
                                    ></b-form-select>
                                </label>
                                <small v-if="isLazyFilterActive" class="ms-3 text-muted">Press Enter to search</small>
                            </div>
                        </form>
                    </div>
                    <div>
                        <button class="btn btn-sm btn-outline-dark px-2" @click="filterBtn = true" id="select-filter"><i class="bx bx-filter"></i> Filters</button>
                        <b-popover
                            :target="`select-filter`"
                            triggers="click"
                            placement="left"
                            :show.sync="filterBtn"
                            custom-class="popover-report"
                        >
                            <template v-slot:title>
                                <div
                                    class="
                                        d-flex
                                        align-items-center
                                        justify-content-between
                                    "
                                >
                                    <small>Filters</small>
                                    <span
                                        class="
                                            bx bx-x
                                            font-size-14
                                            cursor-pointer
                                        "
                                        @click="filterBtn = false"
                                    ></span>
                                </div>
                            </template>
                            <div class="mb-2">
                                <label for="item-cat">Item Category</label>
                                <select id="item-cat" class="form-select" v-model="itemCat">
                                    <option value="All">All</option>
                                    <option :value="x.itemCategory" v-for="x in itemCats" :key="x.id">{{x.itemCategory}}</option>
                                </select>
                            </div>
                            <div>
                                <label for="price-range">Price Range</label>
                                <input type="text" class="form-control mb-2" v-model="priceRange.from" placeholder="From">
                                <input type="text" class="form-control" v-model="priceRange.to" placeholder="To">
                            </div>
                        </b-popover>
                    </div>
                    <!-- End search -->
                </div>
                <div class="px-2 mb-5">
                    <div class="table-responsive mb-0">
                        <b-table
                            class="datatables"
                            :items="filteredData"
                            :fields="fields"
                            responsive="sm"
                            :per-page="perPage"
                            :current-page="currentPage"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :busy="tableBusy"
                            bordered
                            outlined
                            hover
                            striped
                            show-empty
                        >
                            <template #empty="scope">
                                <div class="text-center">
                                    {{ scope.emptyText }}
                                </div>
                            </template>
                            <template #table-busy>
                                <div
                                    class="
                                        d-flex
                                        justify-content-center
                                        align-items-center
                                    "
                                >
                                    <div class="preloader-component me-2">
                                        <div class="status">
                                            <div
                                                class="
                                                    spinner-chase
                                                    w-20px
                                                    h-20px
                                                "
                                            >
                                                <div
                                                    class="chase-dot"
                                                ></div>
                                                <div
                                                    class="chase-dot"
                                                ></div>
                                                <div
                                                    class="chase-dot"
                                                ></div>
                                                <div
                                                    class="chase-dot"
                                                ></div>
                                                <div
                                                    class="chase-dot"
                                                ></div>
                                                <div
                                                    class="chase-dot"
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                            <template #cell(trimmedItemName)="row">
                                <div>
                                    {{ row.item.itemName }}
                                </div>
                                <small>{{ row.item.description }}</small>
                                <div>
                                    <span
                                        v-if="row.item.inDbm"
                                        class="
                                            me-2
                                            badge
                                            bg-primary bg-soft
                                        "
                                        >In DBM</span
                                    >
                                    <span
                                        v-if="row.item.isProcurable"
                                        class="badge bg-primary bg-soft"
                                        >Procurable</span
                                    >
                                </div>
                            </template>
                            <template #cell(profile)="row">
                                <a
                                    href="javascript:void(0);"
                                    @click="updateProfile(row.item)"
                                >
                                    <div v-if="row.item.thumbnailUrl" class="d-flex justify-content-center">
                                        <img
                                            :src="row.item.thumbnailUrl"
                                            height="50"
                                            referrer-policy="no-referrer"
                                        />
                                    </div>
                                    <div
                                        v-else
                                        class="
                                            d-flex
                                            align-items-center
                                            justify-content-center
                                            bg-success bg-gradient
                                        "
                                        style="height: 50px"
                                    >
                                        <i
                                            class="
                                                bx bx-user
                                                text-white
                                                font-size-24
                                            "
                                        ></i>
                                    </div>
                                </a>
                            </template>
                            <template #cell(actions)="row">
                                <div class="float-end">
                                    <b-dropdown
                                        id="dropdown-dropleft"
                                        right
                                        variant="link"
                                        toggle-class="text-decoration-none"
                                        menu-class="dropdown-menu-end"
                                        no-caret
                                    >
                                        <template #button-content>
                                            <i
                                                class="fas fa-ellipsis-v"
                                            ></i>
                                        </template>
                                        <b-dropdown-item
                                            @click="updateItem(row)"
                                            variant="secondary"
                                            ><i
                                                class="
                                                    mdi mdi-update
                                                    font-size-18
                                                    me-1
                                                "
                                            ></i
                                            >Edit</b-dropdown-item
                                        >
                                        <b-dropdown-item
                                            @click="deleteItem(row)"
                                            variant="danger"
                                            ><i
                                                class="
                                                    mdi mdi-trash-can
                                                    font-size-18
                                                    me-1
                                                "
                                            ></i
                                            >Delete</b-dropdown-item
                                        >
                                    </b-dropdown>
                                </div>
                            </template>
                        </b-table>
                    </div>
                    <div
                        class="
                            dataTables_paginate
                            paging_simple_numbers
                            float-end
                        "
                    >
                        <ul
                            class="
                                pagination pagination-rounded
                                mb-0
                            "
                        >
                            <!-- pagination -->
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage"
                            ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div>
        </b-sidebar>
        <ItemForm 
            ref="itemForm" 
            @dropData="onCreate" 
            @get-unit="$emit('get-unit')" 
            @get-item-category="$emit('get-item-category')"
            modalTitle="Update Item" 
            :hideStock="true" 
            :side="true"
        />
  </div>
</template>